module.exports = __webpack_public_path__ + "static/media/Cosa-Obra-Pinot-Noir.b55b4ed0.jpg";